/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Voice_DeepInputs */

const en_settings_voice_deep = /** @type {(inputs: Settings_Voice_DeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deep`)
};

const es_settings_voice_deep = /** @type {(inputs: Settings_Voice_DeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profundo`)
};

/**
* | output |
* | --- |
* | "Deep" |
*
* @param {Settings_Voice_DeepInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_voice_deep = /** @type {((inputs?: Settings_Voice_DeepInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Voice_DeepInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_voice_deep(inputs)
	return en_settings_voice_deep(inputs)
});